import { useSetAtom } from 'jotai'
import { useEffect } from 'react'
import { ConformedBranding } from '../../views/shared/conformed'
import { campaignDetailsRegenerateFromManualAtom, campaignDetailsRegenerateFromUrlAtom } from '../state'

export type UseRegenerateCallbackArguments = {
	onRegenerateFromUrl: (url: string, brand: ConformedBranding) => Promise<void>
	onRegenerateFromManual: (data: {
		title: string
		location: string
		language: string
		requirements: string
	}, brand: ConformedBranding) => Promise<void>
}

export function useRegenerateCallback({
	onRegenerateFromUrl,
	onRegenerateFromManual,
}: UseRegenerateCallbackArguments) {
	const setRegenerateFromUrl = useSetAtom(campaignDetailsRegenerateFromUrlAtom)
	const setRegenerateFromManual = useSetAtom(campaignDetailsRegenerateFromManualAtom)

	useEffect(() => {
		setRegenerateFromUrl(() => onRegenerateFromUrl)
		setRegenerateFromManual(() => onRegenerateFromManual)

		return () => {
			setRegenerateFromUrl(undefined)
			setRegenerateFromManual(undefined)
		}
	}, [onRegenerateFromUrl, onRegenerateFromManual, setRegenerateFromUrl, setRegenerateFromManual])

	return {}
}
